define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/action/Controller",
	"csi/comm/PostRequest"
], function(declare,lang,Controller,PostRequest) {

	function isParentSiteLevel(/*URL*/parentUrl) {
		// summary: checks if it's in Site level view.
		return parentUrl == "centric://APPAREL/Views";
	};

	return declare(Controller, {
		process: function() {
			// summary: issue request so as to be able to receive return value
			var	req = this.m_action.m_request;

			this.setProgress();

			if (isParentSiteLevel(this.m_urlParent)) {
				// if we're in site level, then we can have multiple Sales Markets for the Marketing Look.
				new PostRequest(req.m_module, req.m_operation)
					.addParameter("ParentURL", this.m_urlNode)
					.addParameter("URLs",this.getNode().SalesLooks)
					.post({}).then(lang.hitch(this, this._onPublishResponse));
			} else {
				// if we're in Marketing Look view, then we can have only one Sales Market for the Marketing Look.
				// Because only one can be pushed at a time.
				new PostRequest(req.m_module, req.m_operation)
					.addParameter("ParentURL", this.m_urlParent)
					.addParameter("URL",this.m_urlNode)
					.post({}).then(lang.hitch(this, this._onPublishResponse));
			}
		}
	});
});